import { Link } from 'react-router-dom';
import type { Site, SiteTheme } from '@/types/nav';

const themeStyles: Record<SiteTheme, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-700',
  foreground: 'bg-foreground-100 text-foreground-700',
};

type SiteCardProps = {
  site: Site;
};

export default function SiteCard({ site }: SiteCardProps) {
  return (
    <article className="group flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-primary-50/50 md:p-5">
      <div className="flex items-start gap-3">
        <Link
          to={`/detail/${site.id}`}
          aria-label={`查看 ${site.name} 详情`}
          className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-lg font-heading text-lg font-bold ${themeStyles[site.theme]}`}
        >
          {site.initial}
        </Link>
        <div className="min-w-0 flex-1">
          <Link
            to={`/detail/${site.id}`}
            className="block truncate font-heading text-base font-semibold text-foreground-950 transition-colors hover:text-primary-600"
          >
            {site.name}
          </Link>
          <div className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
            <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-secondary-800">
              {site.subCategory}
            </span>
            <span>{site.region}</span>
          </div>
        </div>
      </div>

      <p className="mt-3 line-clamp-2 text-sm leading-relaxed text-foreground-600">
        {site.description}
      </p>

      <div className="mt-3 flex flex-wrap gap-1.5">
        {site.tags.map((tag) => (
          <span
            key={tag}
            className="rounded-full bg-background-100 px-2 py-0.5 text-[11px] text-foreground-600"
          >
            {tag}
          </span>
        ))}
      </div>

      <div className="mt-auto flex items-center justify-between pt-4">
        <span className="flex items-center gap-1 text-xs text-foreground-500">
          <i className="ri-fire-line text-accent-500"></i>
          热度 {site.hot}
        </span>
        <a
          href={site.url}
          target="_blank"
          rel="noopener noreferrer"
          className="flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-3 py-1.5 text-xs font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          访问官网
          <i className="ri-arrow-right-up-line"></i>
        </a>
      </div>
    </article>
  );
}